/**
 * Provider display names — V98-3 review U13 ("display names for providers
 * everywhere"). Systems and the external-services register store a
 * provider KEY (`anthropic`, `aws-bedrock`); people read its name. Unknown
 * keys are title-cased, never shown raw.
 */
export const PROVIDER_NAMES: Record<string, string> = {
  anthropic: 'Anthropic',
  openai: 'OpenAI',
  'azure-openai': 'Azure OpenAI',
  azure_openai: 'Azure OpenAI',
  'aws-bedrock': 'AWS Bedrock',
  bedrock: 'AWS Bedrock',
  'google-vertex': 'Google Vertex AI',
  vertex: 'Google Vertex AI',
  gemini: 'Google Gemini',
  cohere: 'Cohere',
  mistral: 'Mistral AI',
  huggingface: 'Hugging Face',
  pinecone: 'Pinecone',
  weaviate: 'Weaviate',
  datadog: 'Datadog',
  sentry: 'Sentry',
  github: 'GitHub',
  okta: 'Okta',
  'workers-ai': 'Workers AI',
  ollama: 'Ollama',
};

export function providerName(key: string): string {
  const k = key.trim().toLowerCase();
  if (PROVIDER_NAMES[k]) return PROVIDER_NAMES[k]!;
  return k.split(/[-_\s]+/).filter(Boolean).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') || key;
}
